import { render, staticRenderFns } from "./manage-tags.vue?vue&type=template&id=a9100bfc&scoped=true&"
import script from "./manage-tags.vue?vue&type=script&lang=js&"
export * from "./manage-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9100bfc",
  null
  
)

export default component.exports